import { render, staticRenderFns } from "./recordSecurityInfo.vue?vue&type=template&id=5b2510d8&scoped=true"
import script from "./recordSecurityInfo.vue?vue&type=script&lang=js"
export * from "./recordSecurityInfo.vue?vue&type=script&lang=js"
import style0 from "./recordSecurityInfo.vue?vue&type=style&index=0&id=5b2510d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2510d8",
  null
  
)

export default component.exports